<template>
	<div class="card" style="min-height: 450px;">
        <h6 class="card-header text-primary" > Enroll State</h6>

        <div class="card-body row justify-content-center px-3">
			<form action="#" @submit.prevent class="row justify-content-around">

				<div class="col-md-6">
					<div  class="col-md-11 form-group mb-3">
						<label for="stateName"><span class="text-danger">*</span>Select a State</label>
						<select class="form-control" id="stateName" placeholder="Select State" v-model.trim="$v.formInfo.stateCode.$model"  :class="{'is-invalid':$v.formInfo.stateCode.$error}">
							<option value="" selected>- select a state -</option>
							<option v-for="(state, index) in everyStates" :value="state.stateName+'_'+state.stateCode" :key="index">{{ state.stateName }}</option>
						</select>
					</div>

					<div class="mt-5">
						<div class="col-md-11 form-group mb-2">
							<label for="validatorStatus" class="mr-3"><span class="text-danger">*</span>Does State require Validation ?</label>
							<ToggleButton v-on:change="validatorEvent" id="validatorStatus" class="mb-1"/>
						</div>

						<div v-if="formInfo.validationStatus">
							<div class="col-md-11 form-group mb-3">
								<label for="validator"><span class="text-danger">*</span>Validator Name</label>
								<input class="form-control" id="validator" type="text"  placeholder="Validator Name" v-model.number="$v.formInfo.validator.$model"  :class="{'is-invalid':$v.formInfo.validator.$error}">
							</div>
							
							<div class="col-md-11 form-group mb-3">
								<label for="validatorUrl"><span class="text-danger">*</span>Validator URL</label>
								<input class="form-control" id="validatorUrl" type="text"  placeholder="Validator URL" v-model.number="$v.formInfo.validatorUrl.$model"  :class="{'is-invalid':$v.formInfo.validatorUrl.$error}">
							</div>
						</div>
					</div>
					
					<div class=" mt-5">
						<div class="col-md-10 form-group mb-2">
							<label for="hasPaymentRoute" class="mr-3"><span class="text-danger">*</span>Does State have Payment System ?</label>
							<ToggleButton v-on:change="paymentEvent" id="hasPaymentRoute" class="mb-1"/>
						</div>
						
						<div v-if="formInfo.hasPaymentRoute" class="col-md-10 form-group mb-3">
							<label for="paymentUrl"><span class="text-danger">*</span>Payment URL</label>
							<input class="form-control" id="paymentUrl" type="text"  placeholder="Payment URL" v-model.number="$v.formInfo.paymentUrl.$model"  :class="{'is-invalid':$v.formInfo.paymentUrl.$error}">
						</div>
					</div>
				</div>
				

				<div class="col-md-6">
					<div class="col-md-11 form-group mb-3">
						<label for="logoPath"><span class="text-danger">*</span>State Logo</label>
						<div class="custom-file mb-3">
							<input type="file" :value="formInfo.logo" @change="getLogo" class="custom-file-input" id="validatedCustomFile" required>
							<label class="custom-file-label" for="validatedCustomFile">Choose file...</label>
						</div>
						<!-- <input class="form-control" id="logoPath" type="file"  placeholder="Payment URL" :value="formInfo.logo" @change="getLogo"  :class="{'is-invalid':$v.formInfo.logoPath.$error}"> -->
					</div>

					<div class="mt-4">
						<label for="institutionIds"><span class="text-danger">*</span>Institution IDs</label>
						<div class="col-md-11 mb-3" v-for="(field, i) in formInfo.institutionIds" :key="i">
							<div class="input-group" v-if="i == 0">
								<input type="text" id="institutionIds" class="form-control" placeholder="Institution ID" aria-label="Institution ID" aria-describedby="button-addon2" v-model="field.value">
								<div class="input-group-append">
									<button @click="addIdFields" class="btn btn-secondary" type="button" id="button-addon2">+</button>
								</div>
							</div>

							<div class="form-group" v-else>
								<input type="text" id="institutionIds" class="form-control" placeholder="Institution ID" aria-label="Institution ID" aria-describedby="button-addon2" v-model="field.value" >
							</div>
						</div>

						<!-- If more is added -->
						<!-- <div v-for="(field, i) in institutionIdFields" :key="i" class=" col-md-11 form-group mb-3">
							<input type="text" id="institutionIds" class="form-control" placeholder="Institution ID" aria-label="Institution ID" aria-describedby="button-addon2" v-model="$v.formInfo.institutionIds.$model"  :class="{'is-invalid':$v.formInfo.institutionIds.$error}">
						</div> -->
					</div>
				</div>

				<div class="col-md-12 form-group mt-4 px-4">
					<button class="btn btn-primary btn-sm w-100 ml-2 mr-5" :disabled="$v.formInfo.$invalid || enrolling" type="submit" @click.prevent="enrollState()"> 
						<span class="">Enroll State</span>
						<span v-if="enrolling" class="ml-3 spinner-border spinner-border-sm" role="status">
							<span class="sr-only">Loading...</span>
						</span>
					</button>
				</div>
				
			</form>
			
		</div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { required, minLength, requiredIf, url } from 'vuelidate/lib/validators';
import ToggleButton from '@/components/Dashboard/Appages/Accessories/ToggleButton';

export default {
	name: 'EnrollState',
	
	components: {
		ToggleButton
	},

	computed:{
        ...mapState(['token']),
        ...mapGetters(['everyStates'])
	},
	
	watch: {
		"formInfo.stateCode": function (val) {
			console.log(val)
			console.log( val.split('_'))
			const [ stateName, stateCode ] = val.split('_');
			console.log(stateCode)
			console.log(stateName)
			// this.formInfo.stateCode = stateCode;
			// this.formInfo.stateName = stateName;
			// console.log(this.formInfo.stateName)
		}
	},

	data() {
		return {
			enrolling: false,
			stateHolder: null,
		
			formInfo: {
				stateCode: null,
				stateName: null,
				validationStatus: null,
				validator: null,
				validatorUrl: null,
				hasPaymentRoute: null,
				paymentUrl: null,
				logoPath: null,
				institutionIds: [{value: ""}],
			}
		}
	},

	validations: {
        formInfo: {
            stateCode: { required },
            stateName: { required },
            validationStatus:{ required },
            validator: { 
				required: requiredIf('validationStatus')
			},
            validatorUrl: { 
				required: requiredIf('validationStatus'),
				url
			},
			hasPaymentRoute: { required },
			paymentUrl: { 
				required: requiredIf('hasPaymentRoute'),
				url
			},
			logoPath: { required },
			institutionIds: { required },
        }
    },

	methods: {
		validatorEvent(val) {
			this.formInfo.validationStatus = val;
		},

		paymentEvent(val) {
			this.formInfo.hasPaymentRoute = val;
		},

		getLogo(e){
			console.log(e)
		},

		addIdFields() {
			this.formInfo.institutionIds.push({
				value: "",
			})
		},

		enrollState() {

		}

	}
}
</script>
